<template>
<form class="scan-code light-way">
  <div class="scan-bord">
      <img :src="qrImg" class="code-pic" v-show="status == 1">
      <div class="scan-overdue" v-show="status == 2">
          <p class="scan-txt">二维码已失效</p>
          <a href="" class="btn-com btn-lg btn-red" @click.stop.prevent="refresh">点击刷新</a>
      </div>
      <div class="scan-success" v-show="status == 3">
        <div class="scan-success"></div>
        <p class="scan-ok">扫描成功</p>
      </div>
  </div>
  <p class="scan-tip">请打开喜马拉雅FM App，扫描二维码</p>
  <p class="scan-tip mgt-10">免输入，快速，更安全</p>
</form>
</template>
<script>
import api from '@/api'
function doExpired () {

}
function doLogined () {
  this.destroy()
  window.location.href = this.toUrl
}

export default {
  props: {
    scanWay: Boolean
  },
  data () {
    return {
      status: 1,//waiting=1,expired=2,logined=3
      qrImg: '',
      qrId: '',
      timer: ''
    }
  },
  computed: {
    toUrl () {
      return this.$store.state.toUrl
    }
  },
  methods: {
    getQrImg() {
      api.getQrCode().then(res => {
        if (res.data.ret == 0) {
          this.qrImg = res.data.img
          this.qrId = res.data.qrId
          this.timer = window.setInterval(() => {
            this.checkStatus(this.qrId)
          }, 1500)
        }
      })
    },
    checkStatus (qrId) {
      api.checkQr(qrId).then(res => {
        if (res.data.ret == 0 && this.status !== res.data.status) {
          this.status = res.data.status
          this.changeStatus(this.status)
        }
      })
    },
    refresh () {
      this.destroy()
      this.status = 1
      this.initComp()
    },
    destroy () {
      this.timer && clearInterval(this.timer)
    },
    changeStatus (status) {
      switch(status) {
        case 2:
          doExpired.call(this)
          break
        case 3:
          doLogined.call(this)
          break
        default: break
      }
    },
    initComp () {
      this.getQrImg()
    }
  },
  created () {
    this.initComp()
  },
  destroyed () {
    this.destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/qrcode-login.vue